<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-5">
          <li>
            <router-link to="/setup/usage-rating/time" class="vx-row">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              <h4>{{ $t("setup.label.CreateTimeModel") }}</h4>
            </router-link>
          </li>
        </ul>
      </div>
      <vx-card>
        <div class="vx-row float-right">
          <div class="vx-col w-full">
            <vs-button
              icon-pack="feather"
              icon="icon-plus"
              class="mr-2 mr-3"
              size="small"
              @click="adds('Create TimeModel ')"
              >{{ $t("setup.label.AddTimemodel") }}</vs-button
            >
          </div>
          <!-- </div>
        --></div>
        <!-- <div class="vx-row float-right">
          <div class="vx-col w-full">
            <vs-button
              v-if="true"
              icon-pack="feather"
              icon="icon-list"
              class="mr-3"
              size="small"
              @click="$router.push('/addressmaster').catch(() => {})"
              >{{ $t("label.button.listview") }}</vs-button
            >
          </div>
        </div> -->

        <div class="vx-col" style="margin: 1.5rem 0.8rem">
          <span class="font-medium text-lg leading-none">{{
            $t("setup.label.ExpandAll / CollapseAll")
          }}</span>
          <div class="flex items-end px-3"></div>
        </div>
        <!-- <vs-divider /> -->
        <vs-table
          v-if="false"
          :max-items="descriptionItems[0]"
          pagination
          :data="addresss"
          :description="!treeview"
          :search="!treeview"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-git-branch"
                @click="treeview = !treeview"
                size="small"
                >{{ $t("setup.label.TreeView") }}</vs-button
              >
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="add('TimeModel')"
                size="small"
                >{{ $t("setup.label.AddCountry") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead" v-if="!treeview">
            <vs-th>{{ $t("setup.label.TimeModelName") }}</vs-th>
            <vs-th>{{ $t("setup.label.StartYear") }}</vs-th
            ><vs-th>{{ $t("setup.label.StartMonth") }}</vs-th>
            <vs-th>{{ $t("setup.label.StartDay") }}</vs-th>
          </template>

          <template slot-scope="{ data }" v-if="!treeview">
            <vs-tr
              :key="index"
              :data="address"
              v-for="(address, index) in data"
            >
              <vs-td :data="address.timeModelName">{{
                address.timeModelName
              }}</vs-td>
              <vs-td :data="address.startYear">{{ address.startYear }}</vs-td>
              <vs-td :data="address.startMonth">{{ address.startMonth }}</vs-td>
              <vs-td :data="address.startDay">{{ address.startDay }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div v-if="true">
          <tree-item
            :node="treedata"
            @add-in="addIn"
            @edit-item="editItem"
            @delete-item="deleteItem"
            @service-available="serviceAvailable"
            class="tree-container"
          ></tree-item>
        </div>
      </vx-card>
    </div>

    <delete-popup
      :deletePopup="deletePopup"
      :title="title"
      @deletePressed="removeItem()"
      @cancelPressed="deletePopup = false"
    />

    <!-- //Addd -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        class="popup-close mid-popup"
        :title="$t(' ') + title"
        :active.sync="addPopup"
      >
        <form>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.StartYear")
              }}</small>
              <v-select
                label="fieldType"
                :options="Years"
                v-model="addObj.startYear"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                <!-- <template v-slot:option="option">{{ option.item }}</template> -->
              </v-select>
            </div>
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.EndYear")
              }}</small>
              <v-select
                label="fieldType"
                :options="Years"
                v-model="addObj.endYear"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                <!-- <template v-slot:option="option">{{ option.item }}</template> -->
              </v-select>
            </div>
          </div>

          <div class="center mt-10">
            <span class="ml-1 mr-1">
              <vs-button
                @click="addYear"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("setup.label.Confirm") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
        <validation-popup
          :errorMessage="errorMessage"
          :warningPopup="warningPopup"
          :warningText="warningText"
          @closeWarning="warningPopup = false"
        ></validation-popup>
      </vs-popup>
    </div>
    <!-- //addmonth -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        class="popup-close mid-popup"
        :title="$t(' ') + title"
        :active.sync="addPopupMonth"
      >
        <form>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.StartMonth")
              }}</small>
              <v-select
                label="fieldType"
                :options="Months"
                v-model="addObj.startMonth"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                <!-- <template v-slot:option="option">{{ option.item }}</template> -->
              </v-select>
            </div>
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.EndMonth")
              }}</small>
              <v-select
                label="fieldType"
                :options="Months"
                v-model="addObj.endMonth"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                <!-- <template v-slot:option="option">{{ option.item }}</template> -->
              </v-select>
            </div>
          </div>

          <div class="center mt-10">
            <span class="ml-1 mr-1">
              <vs-button
                @click="addMonth"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("setup.label.Confirm") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
        <validation-popup
          :errorMessage="errorMessage"
          :warningPopup="warningPopup"
          :warningText="warningText"
          @closeWarning="warningPopup = false"
        ></validation-popup>
      </vs-popup>
    </div>
    <!-- //addday -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        class="popup-close mid-popup"
        :title="$t(' ') + title"
        :active.sync="addPopupDay"
      >
        <form>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.StartDay")
              }}</small>
              <v-select
                label="fieldType"
                :options="Days"
                v-model="addObj.startDay"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                <!-- <template v-slot:option="option">{{ option.item }}</template> -->
              </v-select>
            </div>
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.EndDay")
              }}</small>
              <v-select
                label="fieldType"
                :options="Days"
                v-model="addObj.endDay"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                <!-- <template v-slot:option="option">{{ option.item }}</template> -->
              </v-select>
            </div>
          </div>

          <div class="center mt-10">
            <span class="ml-1 mr-1">
              <vs-button
                @click="addDay"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("setup.label.Confirm") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
        <validation-popup
          :errorMessage="errorMessage"
          :warningPopup="warningPopup"
          :warningText="warningText"
          @closeWarning="warningPopup = false"
        ></validation-popup>
      </vs-popup>
    </div>
    <!-- addtime -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        class="popup-close mid-popup"
        :title="$t(' ') + title"
        :active.sync="addPopupTime"
      >
        <form>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <!-- <small class="date-label font-semibold">{{
                $t("Start Time")
              }}</small> -->
              <vs-input
                type="time"
                v-model="addObj.startTime"
                :label="$t('setup.label.StartTime')"
              />
              <!-- <v-select
                label="fieldType"
                :options="Days"
                v-model="addObj.startTime"
                placeholder="--Select One--"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
               
              </v-select> -->
            </div>
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <vs-input type="time" v-model="addObj.endTime" label="End Time" />
              <!-- <small class="date-label font-semibold">{{
                $t("End Time")
              }}</small>
              <v-select
                label="fieldType"
                :options="Days"
                v-model="addObj.endTime"
                placeholder="--Select One--"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
               
              </v-select> -->
            </div>
          </div>

          <div class="center mt-10">
            <span class="ml-1 mr-1">
              <vs-button
                @click="addTime"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("setup.label.Confirm") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
        <validation-popup
          :errorMessage="errorMessage"
          :warningPopup="warningPopup"
          :warningText="warningText"
          @closeWarning="warningPopup = false"
        ></validation-popup>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        class="popup-close mid-popup"
        :title="$t(' ') + title"
        :active.sync="addPopups"
      >
        <form>
          <!-- <div class="vx-col mb-4 sm:w-full w-full">
            <vs-input
              style="margin-top: 10px"
              :label="title + $t(' Code')"
              type="text"
              v-model="addObj.entityCode"
              class="w-full font-semibold starlabel"
            />
          </div> -->

          <div class="vx-col mb-4 sm:w-full w-full">
            <vs-input
              :label="$t('setup.label.Time_Model_Name')"
              type="text"
              v-model="addObj.timeModelName"
              class="w-full font-semibold starlabel"
            />
          </div>

          <h5>{{$t("setup.label.model_includes_which_all_Bands_?")}}</h5>
          <div class="vx-col mb-4 sm:w-full w-full">
            <vs-checkbox
              class="mt-5 mb-5 font-semibold"
              :value="isSelector"
              v-model="addObj.yearRestriction"
              >{{ $t("setup.label.YearRestriction") }}</vs-checkbox
            >
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <vs-checkbox
              class="mt-5 mb-5 font-semibold"
              :value="isSelector"
              v-model="addObj.monthRestriction"
              >{{ $t("setup.label.MonthRestriction") }}</vs-checkbox
            >
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <vs-checkbox
              class="mt-5 mb-5 font-semibold"
              :value="isSelector"
              v-model="addObj.dayRestriction"
              >{{ $t("setup.label.DayRestriction") }}</vs-checkbox
            >
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <vs-checkbox
              class="mt-5 mb-5 font-semibold"
              :value="isSelector"
              v-model="addObj.timeRestriction"
              >{{ $t("setup.label.TimeRestriction") }}</vs-checkbox
            >
          </div>
          <div class="center mt-10">
            <span class="ml-1 mr-1">
              <vs-button
                @click="addEntity1"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("setup.label.Confirm") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
        <validation-popup
          :errorMessage="errorMessage"
          :warningPopup="warningPopup"
          :warningText="warningText"
          @closeWarning="warningPopup = false"
        ></validation-popup>
      </vs-popup>
    </div>

    <!-- //Edit -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example "
        class="popup-close mid-popup"
        :title="$t('Edit ') + title"
        :active.sync="editPopup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">
                <vs-input
                  :label="title + $t('setup.label.Code')"
                  type="text"
                  v-model="addObj.entityCode"
                  class="w-full font-semibold"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full w-full">
              <vs-input
                :label="title + $t('setup.label.Name')"
                type="text"
                v-model="addObj.entityName"
                class="w-full font-semibold"
              />
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editPopup = false">{{
                $t("setup.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button>{{
                $t("setup.label.Submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <!-- edittimemodel -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example "
        class="popup-close mid-popup"
        :title="$t('Edit ') + title"
        :active.sync="editPopupTimemodel"
      >
        <form>
          <div class="vx-col mb-4 sm:w-full w-full">
            <vs-input
              :label="$t('setup.label.Time_Model_Name')"
              type="text"
              v-model="addObj.entityName"
              class="w-full font-semibold starlabel"
            />
          </div>

          <h5>{{$t("setup.label.model_includes_which_all_Bands_?")}}</h5>
          <div class="vx-col mb-4 sm:w-full w-full">
            <vs-checkbox
              class="mt-5 mb-5 font-semibold"
              :value="isSelector"
              v-model="addObj.yearRestriction"
              >{{ $t("setup.label.YearRestriction") }}</vs-checkbox
            >
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <vs-checkbox
              class="mt-5 mb-5 font-semibold"
              :value="isSelector"
              v-model="addObj.monthRestriction"
              >{{ $t("setup.label.MonthRestriction") }}</vs-checkbox
            >
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <vs-checkbox
              class="mt-5 mb-5 font-semibold"
              :value="isSelector"
              v-model="addObj.dayRestriction"
              >{{ $t("setup.label.DayRestriction") }}</vs-checkbox
            >
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <vs-checkbox
              class="mt-5 mb-5 font-semibold"
              :value="isSelector"
              v-model="addObj.timeRestriction"
              >{{ $t("setup.label.TimeRestriction") }}</vs-checkbox
            >
          </div>
          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editPopup = false">{{
                $t("setup.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="editTimemodel">{{
                $t("setup.label.Submit")
              }}</vs-button>
            </span>
          </div>

          <div style="height: 20px"></div>
        </form>
      </vs-popup>
    </div>
    <!-- edityear -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example "
        class="popup-close mid-popup"
        :title="$t('Edit ') + title"
        :active.sync="editPopupYear"
      >
        <form>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("Start Year")
              }}</small>
              <v-select
                label="fieldType"
                :options="Years"
                v-model="addObj.entityName"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                <!-- <template v-slot:option="option">{{ option.item }}</template> -->
              </v-select>
            </div>
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.EndYear")
              }}</small>
              <v-select
                label="fieldType"
                :options="Years"
                v-model="addObj.entityCode"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                <!-- <template v-slot:option="option">{{ option.item }}</template> -->
              </v-select>
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editPopup = false">{{
                $t("setup.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="editYear">{{
                $t("setup.label.Submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <!-- editMonth -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example "
        class="popup-close mid-popup"
        :title="$t('Edit ') + title"
        :active.sync="editPopupMonth"
      >
        <form>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.StartMonth")
              }}</small>
              <v-select
                label="fieldType"
                :options="Months"
                v-model="addObj.entityName"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                <!-- <template v-slot:option="option">{{ option.item }}</template> -->
              </v-select>
            </div>
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.EndMonth")
              }}</small>
              <v-select
                label="fieldType"
                :options="Months"
                v-model="addObj.entityCode"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                <!-- <template v-slot:option="option">{{ option.item }}</template> -->
              </v-select>
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editPopup = false">{{
                $t("setup.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="editMonth">{{
                $t("setup.label.Submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <!-- editday -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example "
        class="popup-close mid-popup"
        :title="$t('Edit ') + title"
        :active.sync="editPopupDay"
      >
        <form>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.StartDay")
              }}</small>
              <v-select
                label="fieldType"
                :options="Days"
                v-model="addObj.entityName"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
              </v-select>
            </div>
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.EndDay")
              }}</small>
              <v-select
                label="fieldType"
                :options="Days"
                v-model="addObj.entityCode"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
              </v-select>
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editPopup = false">{{
                $t("setup.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="editDay">{{
                $t("setup.label.Submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <!-- edittime -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example "
        class="popup-close mid-popup"
        :title="$t('Edit ') + title"
        :active.sync="editPopupTime"
      >
        <form>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <vs-input
                type="time"
                v-model="addObj.entityName"
                :label="$t('setup.label.StartTime')"
              />
              <!-- <small class="date-label font-semibold">{{
                $t("Start Time")
              }}</small>
              <v-select
                label="fieldType"
                :options="Months"
                v-model="addObj.entityName"
                placeholder="--Select One--"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
               
              </v-select> -->
            </div>
          </div>
          <div class="vx-col mb-4 sm:w-full w-full">
            <div class="dropdown-with-label">
              <vs-input
                type="time"
                v-model="addObj.entityCode"
                :label="$t('setup.label.EndTime')"
              />
              <!-- <small class="date-label font-semibold">{{
                $t("End Time")
              }}</small>
              <v-select
                label="fieldType"
                :options="Months"
                v-model="addObj.entityCode"
                placeholder="--Select One--"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
                
              </v-select> -->
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editPopup = false">{{
                $t("setup.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="editTime">{{
                $t("setup.label.Submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <!--///Services-->
  </div>
</template>
<script>
import TreeItem from "./TimeModelTree.vue";
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";
//import moment from "moment";
import vSelect from "vue-select";

import moment from "moment";
import { mapState } from "vuex";
const addEmptyObj = {
  timeModelName: "",
  yearRestriction: "",
  monthRestriction: "",
  dayRestriction: "",
  timeRestriction: "",
  startYear: "",
  endYear: "",
  startMonth: "0",
  endMonth: "0",
  startDay: "0",
  endDay: "0",
  startTime: "0",
  endTime: "0",
  entityName: "",
  entityCode: "",
};
export default {
  data() {
    return {
      addObj: addEmptyObj,
      selectedServices: [],
      availableServices: [],
      searchOption: 0,
      addressTreeObj: [],
      descriptionItems: [5, 10, 15],
      deletePopup: false,
      addPopup: false,
      addPopupMonth: false,
      addPopupDay: false,
      addPopupTime: false,
      addPopups: false,
      editPopup: false,
      editPopupTimemodel: false,
      editPopupYear: false,
      editPopupMonth: false,
      editPopupDay: false,
      editPopupTime: false,
      servicePopup: false,
      treeview: false,
      delId: 0,
      addresss: [],
      service: { id: "" },
      servicePost: { addressId: "", addressType: "", services: [] },
      searchword: "",
      initSelected: ["node-1"],
      treedata: { name: "TimeModels", id: 0, change: 0, children: [] },
      id: "",
      title: "",
      isSelector: "",
      parentId: 0,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      Years: [
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
        "2041",
        "2042",
        "2043",
        "2044",
      ],
      Months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      Days: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
    };
  },

  computed: {
    ...mapState({
      GetTemplate: (state) => state.usageRating.GetTemplate,
    }),
  },
  components: {
    "tree-item": TreeItem,
    Multiselect,
    "v-select": vSelect,
    Datepicker,
  },
  methods: {
    async getaddressList() {
      try {
        const sup = await this.$store.dispatch("usageRating/setTimeModel");
        this.addresss = this.GetTemplate;
      } catch (e) {
        console.log("something went to wrong while addresss:", e);
      }
    },

    async addEntity1() {
      if (!this.addObj.timeModelName) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          delete this.addObj.endDay;
          delete this.addObj.endMonth;
          delete this.addObj.endTime;
          delete this.addObj.endYear;
          delete this.addObj.startDay;
          delete this.addObj.startMonth;
          delete this.addObj.startTime;
          delete this.addObj.startYear;
          delete this.addObj.entityName;
          delete this.addObj.entityCode;
          delete this.addObj.timemodelId;
          delete this.addObj.timeperiodName;
          await this.$store.dispatch(
            "usageRating/saveTimeModelAction",
            this.addObj
          );
          this.addPopups = false;
          this.getaddressList();
          this.resetForm();
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Created Time Model Successful!",
            type: "success",
          });
        } catch (e) {
          if (e.httpStatusCode) {
            this.errorMessage = e.errors[0].defaultUserMessage;
          }
          console.log("something went to wrong while creating entity:", e);
        }
      }
    },
    async addYear() {
      if (!this.addObj.startYear) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          this.addObj.timemodelId = this.parentId;

          delete this.addObj.startDay;
          delete this.addObj.startMonth;
          delete this.addObj.startTime;

          delete this.addObj.endDay;
          delete this.addObj.endMonth;
          delete this.addObj.endTime;

          delete this.addObj.dayRestriction;
          delete this.addObj.monthRestriction;
          delete this.addObj.timeModelName;
          delete this.addObj.timeRestriction;
          delete this.addObj.yearRestriction;
          delete this.addObj.entityCode;
          delete this.addObj.entityName;
          delete this.addObj.description;

          await this.$store.dispatch("usageRating/saveYearAction", this.addObj);
          this.addPopup = false;
          this.getaddressList();
          this.resetForm();
        } catch (e) {
          if (e.httpStatusCode) {
            this.errorMessage = e.errors[0].defaultUserMessage;
          }
          console.log("something went to wrong while creating entity:", e);
        }
      }
    },
    async addMonth() {
      if (!this.addObj.startMonth) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          this.addObj.timemodelId = this.modelId;
          this.addObj.yearId = this.parentId;
          delete this.addObj.dayRestriction;
          delete this.addObj.monthRestriction;
          delete this.addObj.timeModelName;
          delete this.addObj.timeRestriction;
          delete this.addObj.yearRestriction;
          delete this.addObj.entityCode;
          delete this.addObj.entityName;
          delete this.addObj.endYear;
          delete this.addObj.startYear;
          delete this.addObj.description;

          delete this.addObj.endDay;
          delete this.addObj.endTime;
          delete this.addObj.startDay;
          delete this.addObj.startTime;

          await this.$store.dispatch(
            "usageRating/savemonthsAction",
            this.addObj
          );
          this.addPopupMonth = false;
          this.getaddressList();
          this.resetForm();
        } catch (e) {
          if (e.httpStatusCode) {
            this.errorMessage = e.errors[0].defaultUserMessage;
          }
          console.log("something went to wrong while creating entity:", e);
        }
      }
    },
    async addDay() {
      if (!this.addObj.startDay) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          this.addObj.monthId = this.parentId;
          this.addObj.timemodelId = this.modelId;
          delete this.addObj.dayRestriction;
          delete this.addObj.monthRestriction;
          delete this.addObj.timeModelName;
          delete this.addObj.timeRestriction;
          delete this.addObj.yearRestriction;
          delete this.addObj.entityCode;
          delete this.addObj.entityName;
          delete this.addObj.endYear;
          delete this.addObj.startYear;
          delete this.addObj.description;

          delete this.addObj.endMonth;
          delete this.addObj.endTime;
          delete this.addObj.startMonth;
          delete this.addObj.startTime;

          await this.$store.dispatch("usageRating/saveDaysAction", this.addObj);
          this.addPopupDay = false;
          this.getaddressList();
          this.resetForm();
        } catch (e) {
          if (e.httpStatusCode) {
            this.errorMessage = e.errors[0].defaultUserMessage;
          }
          console.log("something went to wrong while creating entity:", e);
        }
      }
    },
    async addTime() {
      if (!this.addObj.startTime) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          this.addObj.timemodelId = this.modelId;
          this.addObj.dayId = this.parentId;
          delete this.addObj.dayRestriction;
          delete this.addObj.monthRestriction;
          delete this.addObj.timeModelName;
          delete this.addObj.timeRestriction;
          delete this.addObj.yearRestriction;
          delete this.addObj.entityCode;
          delete this.addObj.entityName;
          delete this.addObj.endDay;
          delete this.addObj.endMonth;
          delete this.addObj.endYear;
          delete this.addObj.startDay;
          delete this.addObj.startMonth;
          delete this.addObj.startYear;
          await this.$store.dispatch(
            "usageRating/saveTimesAction",
            this.addObj
          );
          this.addPopupTime = false;
          this.getaddressList();
          this.resetForm();
        } catch (e) {
          if (e.httpStatusCode) {
            this.errorMessage = e.errors[0].defaultUserMessage;
          }
          console.log("something went to wrong while creating entity:", e);
        }
      }
    },
    async removeItem() {
      try {
        if (this.title === "TimeModel") {
          await this.$store.dispatch(
            "usageRating/deletetimemodelAction",
            this.id
          );

          this.getaddressList();
        }
        if (this.title === "Year") {
          await this.$store.dispatch(
            "usageRating/deletetimemodelyearAction",
            this.id
          );

          this.getaddressList();
        }
        if (this.title === "Month") {
          await this.$store.dispatch(
            "usageRating/deletetimemodelmonthAction",
            this.id
          );

          this.getaddressList();
        }
        if (this.title === "Day") {
          await this.$store.dispatch(
            "usageRating/deletetimemodeldayAction",
            this.id
          );

          this.getaddressList();
        }
        if (this.title === "Time") {
          await this.$store.dispatch(
            "usageRating/deletetimemodeltimeAction",
            this.id
          );

          this.getaddressList();
        }

        this.getaddressList();
        this.deletePopup = false;
        this.resetForm();
        this.redirect();
      } catch {}
    },

    async editTimemodel() {
      if (!this.addObj.entityName) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          this.addObj.timeModelName = this.addObj.entityName;
          this.addObj.description = this.addObj.entityName;

          delete this.addObj.endDay;
          delete this.addObj.endMonth;
          delete this.addObj.endTime;
          delete this.addObj.endYear;
          delete this.addObj.entityCode;
          delete this.addObj.entityName;
          delete this.addObj.startDay;
          delete this.addObj.startMonth;
          delete this.addObj.startTime;
          delete this.addObj.startYear;
          delete this.addObj.parentEntityId;
          delete this.addObj.timemodelId;
          await this.$store.dispatch("usageRating/editTimeModelAction", {
            id: this.id,
            data: this.addObj,
          });

          this.editPopupTimemodel = false;
          this.resetForm();
          this.redirect();
        } catch (e) {
          if (e.httpStatusCode) {
            this.errorMessage = e.errors[0].defaultUserMessage;
          }
          console.log("something went to wrong while edit Address:", e);
        }
      }
    },
    async editYear() {
      if (!this.addObj.entityName) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          this.addObj.startYear = this.addObj.entityName;
          this.addObj.endYear = this.addObj.entityCode;

          delete this.addObj.endMonth;
          delete this.addObj.endTime;
          delete this.addObj.endDay;
          delete this.addObj.entityCode;
          delete this.addObj.entityName;
          delete this.addObj.startMonth;
          delete this.addObj.startTime;
          delete this.addObj.startDay;
          delete this.addObj.parentEntityId;
          delete this.addObj.dayRestriction;
          delete this.addObj.monthRestriction;
          delete this.addObj.timeModelName;
          delete this.addObj.timeRestriction;
          delete this.addObj.yearRestriction;
          await this.$store.dispatch("usageRating/updateYearAction", {
            id: this.id,
            data: this.addObj,
          });

          this.editPopupYear = false;
          this.resetForm();
          this.redirect();
        } catch (e) {
          if (e.httpStatusCode) {
            this.errorMessage = e.errors[0].defaultUserMessage;
          }
          console.log("something went to wrong while edit Address:", e);
        }
      }
    },
    async editMonth() {
      if (!this.addObj.entityName) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          this.addObj.startMonth = this.addObj.entityName;
          this.addObj.endMonth = this.addObj.entityCode;

          delete this.addObj.endDay;
          delete this.addObj.endTime;
          delete this.addObj.endYear;
          delete this.addObj.entityCode;
          delete this.addObj.entityName;
          delete this.addObj.startDay;
          delete this.addObj.startTime;
          delete this.addObj.startYear;
          delete this.addObj.parentEntityId;
          delete this.addObj.dayRestriction;
          delete this.addObj.monthRestriction;
          delete this.addObj.timeModelName;
          delete this.addObj.timeRestriction;
          delete this.addObj.yearRestriction;
          await this.$store.dispatch("usageRating/updatemonthsAction", {
            id: this.id,
            data: this.addObj,
          });

          this.editPopupMonth = false;
          this.resetForm();
          this.redirect();
        } catch (e) {
          if (e.httpStatusCode) {
            this.errorMessage = e.errors[0].defaultUserMessage;
          }
          console.log("something went to wrong while edit Address:", e);
        }
      }
    },
    async editDay() {
      if (!this.addObj.entityName) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          this.addObj.startDay = this.addObj.entityName;
          this.addObj.endDay = this.addObj.entityCode;

          delete this.addObj.endMonth;
          delete this.addObj.endTime;
          delete this.addObj.endYear;
          delete this.addObj.entityCode;
          delete this.addObj.entityName;
          delete this.addObj.startMonth;
          delete this.addObj.startTime;
          delete this.addObj.startYear;
          delete this.addObj.parentEntityId;
          delete this.addObj.dayRestriction;
          delete this.addObj.monthRestriction;
          delete this.addObj.timeModelName;
          delete this.addObj.timeRestriction;
          delete this.addObj.yearRestriction;
          await this.$store.dispatch("usageRating/updateDaysAction", {
            id: this.id,
            data: this.addObj,
          });

          this.editPopupDay = false;
          this.resetForm();
          this.redirect();
        } catch (e) {
          if (e.httpStatusCode) {
            this.errorMessage = e.errors[0].defaultUserMessage;
          }
          console.log("something went to wrong while edit Address:", e);
        }
      }
    },
    async editTime() {
      if (!this.addObj.entityName) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          this.addObj.startTime = this.addObj.entityName;
          this.addObj.endTime = this.addObj.entityCode;

          delete this.addObj.endMonth;
          delete this.addObj.endDay;
          delete this.addObj.endYear;
          delete this.addObj.entityCode;
          delete this.addObj.entityName;
          delete this.addObj.startMonth;
          delete this.addObj.startDay;
          delete this.addObj.startYear;
          delete this.addObj.parentEntityId;
          delete this.addObj.dayRestriction;
          delete this.addObj.monthRestriction;
          delete this.addObj.timeModelName;
          delete this.addObj.timeRestriction;
          delete this.addObj.yearRestriction;
          await this.$store.dispatch("usageRating/updateTimesAction", {
            id: this.id,
            data: this.addObj,
          });

          this.editPopupTime = false;
          this.resetForm();
          this.redirect();
        } catch (e) {
          if (e.httpStatusCode) {
            this.errorMessage = e.errors[0].defaultUserMessage;
          }
          console.log("something went to wrong while edit Address:", e);
        }
      }
    },

    redirect() {
      this.getaddressList();
    },
    editData(id) {
      this.$router.push(`/editaddress/${id}`);
    },
    resetForm() {
      this.addObj = addEmptyObj;
      this.addObj.yearRestriction = "";
      this.selected = [];
      this.addObj.monthRestriction = "";
      this.addObj.dayRestriction = "";
      this.addObj.timeRestriction = "";
      this.addObj.timeModelName = "";
    },

    addIn(id, type, code, modelId) {
      if (type === "Year") {
        this.title = "Year";
        this.parentId = id;
        this.modelId = id;
        this.addPopup = true;
      } else if (type === "Month") {
        this.title = "Month";
        this.parentId = id;
        this.modelId = modelId;
        this.yearId = this.addPopupMonth = true;
      } else if (type === "Day") {
        this.title = "Day";
        this.parentId = id;
        this.modelId = modelId;
        this.addPopupDay = true;
      } else if (type === "Time") {
        this.title = "Time";
        this.parentId = id;
        this.modelId = modelId;
        this.addPopupTime = true;
      }
      (this.addObj.entityCode = ""), (this.addObj.entityName = "");
    },
    editItem(id, type, code, name, end, node) {
      if (type === "country") {
        this.title = "TimeModel";
        this.id = id;
        this.addObj.entityCode = code;
        this.addObj.entityName = name;
        this.addObj.yearRestriction = node.allowedChild.includes("year");
        this.addObj.monthRestriction = node.allowedChild.includes("month");
        this.addObj.dayRestriction = node.allowedChild.includes("day");
        this.addObj.timeRestriction = node.allowedChild.includes("time");

        this.editPopupTimemodel = true;
      } else if (type === "state") {
        this.title = "Year";
        this.addObj.entityCode = end;
        this.addObj.entityName = code;
        this.id = id;
        this.editPopupYear = true;
      } else if (type === "district") {
        this.title = "Month";
        this.id = id;
        this.addObj.entityCode = end;
        this.addObj.entityName = code;
        this.editPopupMonth = true;
      } else if (type === "city") {
        this.title = "Day";
        this.id = id;
        this.addObj.entityCode = end;
        this.addObj.entityName = code;
        this.editPopupDay = true;
      } else if (type === "time") {
        this.title = "Time";
        this.id = id;
        this.addObj.entityCode = end;
        this.addObj.entityName = code;
        this.editPopupTime = true;
      }
    },
    deleteItem(id, type, code) {
      if (type === "country") {
        this.title = "TimeModel";
        this.id = id;
        this.deletePopup = true;
      }
      if (type === "state") {
        this.title = "Year";
        this.id = id;
        this.deletePopup = true;
      }
      if (type === "district") {
        this.title = "Month";
        this.id = id;
        this.deletePopup = true;
      }
      if (type === "city") {
        this.title = "Day";
        this.id = id;
        this.deletePopup = true;
      }
      if (type === "time") {
        this.title = "Time";
        this.id = id;
        this.deletePopup = true;
      }
    },

    serviceAvailable(id, type, code) {
      this.getSelectedServices(id, type);
      this.id = id;
      this.servicePopup = true;
      this.title = type;
    },
    add(title) {
      this.title = title;
      this.addPopup = true;
    },
    adds(title) {
      this.title = title;
      this.addPopups = true;
    },
    listToTree(list) {
      var map = {},
        node,
        roots = [],
        i;
      for (i = 0; i < list.length; i += 1) {
        map[list[i].code] = i;
        list[i].children = [];
      }
      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parent !== undefined) {
          node.allowedChild = list[map[node.parent]].allowedChild;
          list[map[node.parent]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      this.treedata.children = roots;
    },
    convertTree(val) {
      const addressMap = new Map();
      val.map((el) => {
        const allowedChild = [];
        if (el.yearrestriction) allowedChild.push("year");
        if (el.monthrestriction) allowedChild.push("month");
        if (el.dayrestriction) allowedChild.push("day");
        if (el.timerestriction) allowedChild.push("time");
        addressMap.set(el.timemodelName, {
          name: el.timemodelName,
          code: el.timemodelName,
          type: "country",
          allowedChild: allowedChild,
          id: el.timemodelId,
          modelId: el.timemodelId,
          end: el.timemodelId,
          dis: el.yearrestriction,
        });
        if (el.year) {
          el.year.map((d) => {
            addressMap.set(d.startYear, {
              name: d.startYear + "-" + d.endYear,
              code: d.startYear,
              parent: el.timemodelName,
              type: "state",
              id: d.yearId,
              modelId: el.timemodelId,
              end: d.endYear,
              dis: el.yearrestriction,
            });
          });
          this.checkMonth(el, addressMap);
        } else {
          this.checkMonth(el, addressMap);
        }
      });
      const addressList = [...addressMap.values()];
      this.listToTree(addressList);
    },
    checkMonth(el, addressMap) {
      if (el.year) {
        el.year.map((x) => {
          x.month.map((y) => {
            addressMap.set(y.startMonth, {
              name: y.startMonth + "-" + y.endMonth,
              code: y.startMonth,
              parent:
                x.startYear && x.startYear != "0"
                  ? x.startYear
                  : null || el.timemodelName,
              type: "district",
              id: y.monthId,
              modelId: el.timemodelId,
              end: y.endMonth,
              dis: el.monthrestriction,
            });
          });
        });
        this.checkDay(el, addressMap);
      } else this.checkDay(el, addressMap);
    },
    checkDay(el, addressMap) {
      if (el.year) {
        el.year.map((x) => {
          x.month.map((y) => {
            y.day.map((z) => {
              addressMap.set(z.startDay, {
                name: z.startDay + "-" + z.endDay,
                code: z.startDay,
                parent:
                  y.startMonth && y.startMonth != "0"
                    ? y.startMonth
                    : null || (x.startYear && x.startYear != "0")
                    ? x.startYear
                    : null || el.timemodelName,
                type: "city",
                id: z.dayId,
                end: z.endDay,
                modelId: el.timemodelId,
                dis: el.dayrestriction,
              });
            });
          });
        });
        this.checkTime(el, addressMap);
      } else this.checkTime(el, addressMap);
    },
    checkTime(el, addressMap) {
      el.year.map((x) => {
        x.month.map((y) => {
          y.day.map((z) => {
            z.time.map((et) => {
              addressMap.set(et.startTime, {
                name: et.startTime + "-" + et.endTime,
                code: et.startTime,
                parent:
                  z.startDay && z.startDay != "0"
                    ? z.startDay
                    : null || (y.startMonth && y.startMonth != "0")
                    ? y.startMonth
                    : null || (x.startYear && x.startYear != "0")
                    ? x.startYear
                    : null || el.timemodelName,
                type: "time",
                id: et.timeId,
                end: et.endTime,
                modelId: el.timemodelId,
                dis: el.timerestriction,
              });
            });
          });
        });
      });
    },
  },
  watch: {
    addresss(val) {
      this.convertTree(val);
      // this.addDistricts(val);
    },
  },
  mounted() {
    this.getaddressList();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.tree-block {
  float: left;
  width: 33%;
  padding: 10px;
  box-sizing: border-box;
  border: 1px dotted #ccccdd;
  overflow: auto;
  height: 800px;
}
.treebtn1 {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 1px 3px;
  border-radius: 5px;
  margin-right: 5px;
  color: rgb(148, 147, 147);
}
.treebtn2 {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 3px 5px;
  border-radius: 5px;
  margin-left: 5px;
  color: rgb(97, 97, 97);
}
.treebtn3 {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 3px 5px;
  border-radius: 5px;
  margin-left: 5px;
  color: rgb(63, 63, 63);
}
.tree-search-input {
  width: 70%;
  padding: 6px 8px;
  outline: none;
  border-radius: 6px;
  border: 1px solid #ccc;
}
.tree-search-btn {
  width: 25%;
  padding: 6px 8px;
  outline: none;
  border-radius: 6px;
  background-color: rgb(218, 218, 218);
  border: 1px solid rgb(226, 225, 225);
  color: rgb(117, 117, 117);
}
</style>
<style lang="scss">
.multiselect__tag {
  color: rgb(48, 48, 48);
  background-color: rgba(var(--vs-primary), 0.3);
  font-size: 01rem;
}
.multiselect__tag:hover {
  background-color: rgba(var(--vs-warning), 0.3);
}

.multiselect__option--disabled {
  background: purple;
  color: rgba(var(--vs-primary), 1);
  font-style: italic;
}

.multiselect__option--highlight {
  background-color: rgba(var(--vs-primary), 1);
  color: rgb(255, 255, 255);
  font-size: 0.9rem;
  height: 1rem;
}

.multiselect__content {
  background: rgb(255, 255, 255);
  color: #444;
  font-size: 0.9rem;
}
.multiselect__single {
  height: 0.8rem;
  font-size: 01rem;
  color: #444;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 0.25rem 1.625rem 0.25rem 0.625rem;

  margin-right: 0.625rem;

  line-height: 1;

  margin-bottom: 0.5rem;
}
.tree-container {
  max-width: 26rem;
}
</style>
